import React, { Suspense, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import MarketingRoutes from "./MarketingRoutes";
import AdminRoutes from "./AdminRoutes";
import Alert from "./components/Utils/Alert";
import { useRecoilState } from "recoil";
import { LoginState } from "./components/GlobalStates/LoginState";

function App() {
  const [loginState, setLoginState] = useRecoilState(LoginState);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) setLoginState(true);
    else setLoginState(false);
  });

  return (
    <BrowserRouter>
      <Suspense fallback={<div>Loading...</div>}>
        <Alert />
        <MarketingRoutes />
        <AdminRoutes />
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
